import { resolveFileExtension } from "./fileTypeIcons";

export const FILE_PREVIEW_KIND = {
  PDF: "pdf",
  IMAGE: "image",
  TEXT: "text",
  EXCEL: "excel",
  UNSUPPORTED: "unsupported",
};

const IMAGE_EXTENSIONS = new Set(["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"]);
const TEXT_EXTENSIONS = new Set(["txt", "csv", "html", "htm", "json", "xml", "log", "md"]);
const EXCEL_EXTENSIONS = new Set(["xls", "xlsx"]);
const PDF_EXTENSIONS = new Set(["pdf"]);

const isPdfMime = (mime) => {
  const normalized = String(mime || "").toLowerCase();
  return normalized === "application/pdf" || normalized.includes("pdf");
};

const isImageMime = (mime) => String(mime || "").toLowerCase().startsWith("image/");

const isTextMime = (mime) => {
  const normalized = String(mime || "").toLowerCase();
  return normalized.startsWith("text/") || normalized === "application/json" || normalized === "application/xml";
};

const isExcelMime = (mime) => {
  const normalized = String(mime || "").toLowerCase();
  return (
    normalized === "application/vnd.ms-excel" ||
    normalized === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    normalized.includes("spreadsheet")
  );
};

export const getFilePreviewKind = (fileName, mimeType) => {
  const extension = resolveFileExtension(fileName, mimeType);

  if (PDF_EXTENSIONS.has(extension) || isPdfMime(mimeType)) {
    return FILE_PREVIEW_KIND.PDF;
  }

  if (IMAGE_EXTENSIONS.has(extension) || isImageMime(mimeType)) {
    return FILE_PREVIEW_KIND.IMAGE;
  }

  if (TEXT_EXTENSIONS.has(extension) || isTextMime(mimeType)) {
    return FILE_PREVIEW_KIND.TEXT;
  }

  if (EXCEL_EXTENSIONS.has(extension) || isExcelMime(mimeType)) {
    return FILE_PREVIEW_KIND.EXCEL;
  }

  return FILE_PREVIEW_KIND.UNSUPPORTED;
};

export const canPreviewFile = (kind) =>
  kind === FILE_PREVIEW_KIND.PDF ||
  kind === FILE_PREVIEW_KIND.IMAGE ||
  kind === FILE_PREVIEW_KIND.TEXT ||
  kind === FILE_PREVIEW_KIND.EXCEL;

export const EXCEL_PREVIEW_MAX_ROWS = 100;
export const EXCEL_PREVIEW_MAX_COLS = 20;
